<template>
  <l-map style="height: 900px;" :zoom="zoom" :center="center">
    <!-- <l-control-layers position="topright"></l-control-layers> -->

    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <!-- <l-draw-toolbar position="toplright"/> -->
    <l-freedraw v-model="polygons" :mode="mode" />
    <l-marker-cluster>
      <l-marker
        v-for="(item, index) in markers"
        :key="'marker-' + index"
        :lat-lng="item.point"
        @click="markerClick(item.name)"
      >
        <l-tooltip
          ><div>
            <CRow>
              <CButton>
                <CIcon name="cil-user" class="text-info" size="lg" />{{
                  item.name
                }}
              </CButton></CRow
            >
            <CRow>
              <CButton>
                <CIcon name="cil-user" class="text-danger" size="lg" />{{
                  item.name
                }}
              </CButton></CRow
            >
          </div></l-tooltip
        >
        <l-icon >          
            <img src="../../../public/img/carlocation_sm_g.png"/>
        </l-icon>
      </l-marker>
    </l-marker-cluster>

    <l-polyline :lat-lngs="polyline.latlngs" :color="polyline.color">
      <l-tooltip>
        <div>
          <CRow>
            <CButton>
              <CIcon name="cil-user" class="text-info" size="lg" /> </CButton
          ></CRow>
          <CRow>
            <CButton>
              <CIcon name="cil-user" class="text-danger" size="lg" /> </CButton
          ></CRow>
        </div>
      </l-tooltip>
    </l-polyline>
  </l-map>
</template>

<script>
import Vue from "vue";
// import LDrawToolbar from 'vue2-leaflet-draw-toolbar';
import LFreeDraw from "vue2-leaflet-freedraw";
import { NONE, ALL } from "leaflet-freedraw";

Vue.component("l-marker-cluster", Vue2LeafletMarkerCluster);
// Vue.component('l-draw-toolbar', LDrawToolbar);
Vue.component("l-freedraw", LFreeDraw);

import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LPolyline,
  LControlLayers,
  LIcon,
} from "vue2-leaflet";
// import vue2leafletdrawtoolbar from "vue2-leaflet-draw-toolbar";

import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "leafLeft",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPolyline,
    LControlLayers,
    LIcon,
  },

  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 4,
      center: [34.504, 48.26],
      markerLatLng: [34.504, 48.26],
      markerLatLng2: [34.104, 48.11],
      markers: [
        { point: [34.504, 48.26], name: "nasser" },
        { point: [34.104, 48.11], name: "hamid" },
        { point: [35.504, 47.26], name: "alireza" },
        { point: [36.104, 46.11], name: "amir" },
        { point: [34.504, 58.26], name: "saeed" },
        { point: [34.104, 58.11], name: "nasser" },
        { point: [35.504, 57.26], name: "nasser" },
        { point: [36.104, 56.11], name: "nasser" },
      ],

      polyline: {
        latlngs: [
          [34.504, 50.26],
          [34.104, 51.11],
          [35.504, 52.26],
          [36.104, 53.11],
          [37.504, 54.26],
          [38.104, 55.11],
          [39.504, 56.26],
          [40.104, 57.11],
        ],
        color: "green",
      },
      clusterOptions: {
        disableClusteringAtZoom: 18,
        chunkedLoading: true,
      },

      polygons: [],
      isActive: false,
    };
  },

  computed: {
    mode() {
      return this.isActive ? ALL : NONE;
    },
  },
  methods: {
    flipActive() {
      this.isActive = !this.isActive;
    },
    markerClick(e) {
      console.log(e);
    },
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>